import { useLocalStorage } from '@/hooks/useLocalStorage';

export interface UserSession {
  email: string;
}

const DEFAULT_SESSION: Partial<UserSession> = {};

export function useUserSession(): UserSession {
  const { data } = useLocalStorage<Partial<UserSession>>('user_session', DEFAULT_SESSION);

  return {
    email: data.email ?? 'unknown@keystone.ai',
  };
}
